import { Typography } from '@mui/material'
import { t } from 'i18next'
import i18n from 'lib/i18'
import { contentLanguages } from 'lib/languages'
import theme from 'lib/theme'
import { LabelsWrapper } from 'views/Orders/Orders.styled'

export const OrderLabels = ({
  labels,
  asapSlotLabel,
}: {
  labels: { [key: string]: string }[]
  asapSlotLabel: boolean
}) => {
  return (
    <>
      {labels.map((label, i) => {
        const labelText =
          label[contentLanguages[0]] ||
          label[i18n.language] ||
          Object.values(label)[0]
        return (
          <LabelsWrapper
            ml={1}
            backgroundColor={theme.palette.icon.hover}
            // eslint-disable-next-line react/no-array-index-key
            key={labelText + i}>
            <Typography
              color={theme.palette.commonColors.white}
              variant='body2'>
              {labelText}
            </Typography>
          </LabelsWrapper>
        )
      })}
      {asapSlotLabel && (
        <LabelsWrapper ml={1} backgroundColor={theme.palette.icon.hover}>
          <Typography color={theme.palette.commonColors.white} variant='body2'>
            {t('ASAP')}
          </Typography>
        </LabelsWrapper>
      )}
    </>
  )
}
